import { render, staticRenderFns } from "./MedicalOrder.vue?vue&type=template&id=b6ebfa2e"
import script from "./MedicalOrder.vue?vue&type=script&lang=js"
export * from "./MedicalOrder.vue?vue&type=script&lang=js"
import style0 from "./MedicalOrder.vue?vue&type=style&index=0&id=b6ebfa2e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports